import { render, staticRenderFns } from "./CardTarefas.vue?vue&type=template&id=20601d9f&"
import script from "./CardTarefas.vue?vue&type=script&lang=js&"
export * from "./CardTarefas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports